export function Disclaimer() {
  return (
    <div className="mt-8 bg-gray-50 border border-gray-200 rounded-lg p-4">
      <p className="text-xs text-gray-600">
        <strong>Disclaimer:</strong> The health district does not guarantee the accuracy
        of the information reported on this application and disclaims liability for any
        errors. Inspections are posted online approximately 5 business days following the
        inspection. These records provide a snapshot of the day and time of the
        inspection and may not be representative of the overall, long-term cleanliness of
        an establishment.
      </p>
    </div>
  );
}
